
export default {
  props: ["item", "size","subtitle","noSubtitle","extraClass","popup","stores","extraClassIcon"],
  name: "availability",
  data() {
    return {
    };
  },
  computed: {
    hideStockSubtitle() {
      if (this.$store.getters.store._id !== '601d2fe6cd132303076e7c51') return false;
      const s = String(((this.item || {}).availability || {}).subtitle || '').trim();
      return /^\d+(\s+σε\s+απόθεμα)?$/.test(s);
    },
  },
};
